import React, { useEffect, useRef } from 'react';
import { CallbackListener, Player, PlayerRef } from "@remotion/player";
import { ProjectState } from "../shared";
import AllLayers from './Layers/AllLayers';

type Props = {
    project: ProjectState,
    seekToFrame?: number,
    shouldPlay?: boolean,
    onFrameUpdate?: (frame: number) => void;
    onPlay?: () => void;
    onPause?: () => void;
}
function RemotionPlayer({ 
  project, 
  seekToFrame,
  shouldPlay,
  onFrameUpdate,
  onPlay,
  onPause,
}: Props) {
  const playerRef = useRef<PlayerRef>(null);

  useEffect(() => {
    if (seekToFrame === undefined) return;
    if (!playerRef.current) return;
    playerRef.current.seekTo(seekToFrame);
  }, [seekToFrame]);

  useEffect(() => {
    if (!playerRef.current) return;
    console.log('shouldPlay', shouldPlay)
    if (shouldPlay) {
      playerRef.current.play();
    } else {
      playerRef.current.pause();
    }
  }, [shouldPlay]);

  useEffect(() => {
    if (!playerRef.current) return;
    const player = playerRef.current;
    const _onFrameUpdate: CallbackListener<"frameupdate"> = (e) => {
      const frame = e.detail.frame;
      onFrameUpdate?.(frame);
    };
    player.addEventListener("frameupdate", _onFrameUpdate);
    return () => {
      player.removeEventListener("frameupdate", _onFrameUpdate);
    }
  }, [onFrameUpdate]);

  useEffect(() => {
    if (!playerRef.current) return;
    const player = playerRef.current;
    const _onFrameUpdate: CallbackListener<"play"> = (e) => {
      onPlay?.();
    };
    player.addEventListener("play", _onFrameUpdate);
    return () => {
      player.removeEventListener("play", _onFrameUpdate);
    }
  }, [onPlay]);

  useEffect(() => {
    if (!playerRef.current) return;
    const player = playerRef.current;
    const _onFrameUpdate: CallbackListener<"pause"> = (e) => {
      onPause?.();
    };
    player.addEventListener("pause", _onFrameUpdate);
    return () => {
      player.removeEventListener("pause", _onFrameUpdate);
    }
  }, [onPause]);

  if (!project.dimensions.width || !project.dimensions.height) return null;
  return (
    <Player
      ref={playerRef}
      component={AllLayers}
      durationInFrames={Math.max(1, Math.round(project.durationInFrames))}
      compositionWidth={project.dimensions.width}
      compositionHeight={project.dimensions.height}
      fps={project.fps}
      inputProps={project}
      loop={true}
      controls={true}
      autoPlay={false}
      showVolumeControls={false} />
  );
}

export default RemotionPlayer;
